// Mock data for GOS MÉDIA landing page

export const companyInfo = {
  name: "GOS MÉDIA",
  tagline: "Capturez l'Excellence de Vos Moments Précieux",
  description: "Votre partenaire de confiance pour une couverture événementielle professionnelle en photos et vidéos.",
  phone: "+243 999 006 868",
  email: "gosmediapro@gmail.com",
  whatsapp: "+243999006868",
  address: "Lubumbashi, C/ Kamalondo, Av/ Lunda"
};

export const services = [
  {
    id: 1,
    title: "Mariages",
    description: "Immortalisez le plus beau jour de votre vie avec une couverture complète photo et vidéo de haute qualité.",
    icon: "heart"
  },
  {
    id: 2,
    title: "Dot & Cérémonies Traditionnelles",
    description: "Préservez vos traditions et moments culturels précieux avec notre expertise en photographie événementielle.",
    icon: "crown"
  },
  {
    id: 3,
    title: "Conférences",
    description: "Documentation professionnelle de vos conférences, séminaires et événements d'entreprise.",
    icon: "briefcase"
  },
  {
    id: 4,
    title: "Événements Gouvernementaux",
    description: "Couverture officielle avec le plus haut niveau de professionnalisme et de discrétion.",
    icon: "landmark"
  },
  {
    id: 5,
    title: "Événements Corporatifs",
    description: "Galas, lancements de produits, et célébrations d'entreprise capturés avec excellence.",
    icon: "building2"
  },
  {
    id: 6,
    title: "Autres Événements",
    description: "Anniversaires, baptêmes, fêtes privées - chaque moment mérite d'être immortalisé.",
    icon: "sparkles"
  }
];

export const portfolioImages = [
  {
    id: 1,
    url: "https://images.pexels.com/photos/18220881/pexels-photo-18220881.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Mariage",
    title: "Mariage Élégant en Plein Air"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678",
    category: "Conférence",
    title: "Grande Conférence Internationale"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04",
    category: "Conférence",
    title: "Présentation Professionnelle"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/26202153/pexels-photo-26202153.jpeg",
    category: "Corporate",
    title: "Événement d'Entreprise"
  },
  {
    id: 5,
    url: "https://images.pexels.com/photos/35042459/pexels-photo-35042459.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Gala",
    title: "Soirée Gala Luxueuse"
  },
  {
    id: 6,
    url: "https://images.pexels.com/photos/23710022/pexels-photo-23710022.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Corporate",
    title: "Célébration Corporate"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "M. & Mme Tshibanda",
    event: "Mariage - Septembre 2024",
    text: "Nous avons eu nos photos de mariage 24h après la cérémonie, la qualité est incroyable ! Un service ultra-rapide et professionnel.",
    rating: 5
  },
  {
    id: 2,
    name: "Famille Kabongo",
    event: "Dot Traditionnelle - Août 2024",
    text: "Impressionnés par la rapidité ! Photos et vidéos livrées en 48h. Équipe très réactive et à l'écoute. Résultat magnifique.",
    rating: 5
  },
  {
    id: 3,
    name: "M. Mwamba Patrick",
    event: "Conférence d'Entreprise - Octobre 2024",
    text: "Livraison en 72h comme promis. Qualité professionnelle exceptionnelle. Je recommande GOS MÉDIA sans hésitation !",
    rating: 5
  },
  {
    id: 4,
    name: "Mme Kalala Grace",
    event: "Mariage - Novembre 2024",
    text: "Fini l'attente d'un mois ! J'ai reçu mes photos en 2 jours. L'équipe est talentueuse et ponctuelle. Merci GOS MÉDIA !",
    rating: 5
  }
];

export const socialMedia = [
  {
    name: "Facebook",
    url: "#",
    icon: "facebook"
  },
  {
    name: "Instagram",
    url: "#",
    icon: "instagram"
  },
  {
    name: "Twitter",
    url: "#",
    icon: "twitter"
  },
  {
    name: "YouTube",
    url: "#",
    icon: "youtube"
  },
  {
    name: "LinkedIn",
    url: "#",
    icon: "linkedin"
  }
];

export const stats = [
  {
    number: "500+",
    label: "Événements Couverts"
  },
  {
    number: "1000+",
    label: "Clients Satisfaits"
  },
  {
    number: "4+",
    label: "Années d'Expérience"
  },
  {
    number: "50K+",
    label: "Photos Capturées"
  }
];

// Mock functions for form submissions
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (process.env.NODE_ENV === 'development') {
        console.log('Contact form submitted (MOCK):', formData);
      }
      localStorage.setItem('lastContact', JSON.stringify(formData));
      resolve({ success: true, message: "Merci ! Nous vous contactons bientôt." });
    }, 1000);
  });
};

export const subscribeNewsletter = async (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (process.env.NODE_ENV === 'development') {
        console.log('Newsletter subscription (MOCK):', email);
      }
      const subscribers = JSON.parse(localStorage.getItem('newsletter_subscribers') || '[]');
      subscribers.push({ email, date: new Date().toISOString() });
      localStorage.setItem('newsletter_subscribers', JSON.stringify(subscribers));
      resolve({ success: true, message: "Inscription réussie !" });
    }, 800);
  });
};
